import React from 'react';
import moment from 'moment';
// import { Link } from 'react-router-dom';
// import { API_URL } from '../../../../constants/ApplicationUrl';
// import { SUPPORTING_DOCUMENTS, headerSortingStyle } from '../../../../constants';
// import { ROLES } from '../../../../constants/Roles';
// import { storage } from '../../../../dependencies/store/storage';


const columns = [
    {
        dataField: 'id',
        text: 'Sr.No',
        formatter: (cell, row, rowIndex) => {
            return rowIndex + 1
        }
    }, {
        dataField: 'incompleteDate',
        text: 'Incomplete Date',
        formatter: (cell, row, rowIndex) => {
            if(cell){
                return moment(cell).format('DD-MM-YYYY');
            }
        }
    },
    {
        dataField: 'incompleteReasons',
        text: 'Incomplete Reasons',
        formatter: (cell, row, rowIndex) => {
            if (cell) {
                return cell.map((element, index) => {
                    if (element.reason == 'Others- If any other, please specify. A field to enter other reason with 1000 character limit.') {
                        return <div>  {index + 1}. {row.incompleteDescription}</div>
                    } else {
                        return <div>  {index + 1}. {element.reason}</div>
                    }
                })
            }
        }
    }
];


export default columns;
